import { useEffect, useRef } from 'react';
import { toast } from 'sonner';
import { generateRecurring } from '../../../ledger/plans';
import { useData } from '../../store/data';
import { monthKey } from './useBudget';

/**
 * Mỗi lần mở v2 (một lần/phiên/tháng): sinh các khoản định kỳ của tháng này thành dự chi/dự thu CHỜ XÁC NHẬN.
 * Chống trùng nằm ở tầng ghi (id xác định + transaction) nên mở nhiều tab/thiết bị vẫn an toàn.
 */
export const useRecurringGenerator = (uid: string | undefined) => {
  const templates = useData(s => s.data.recurringTemplates);
  const ready = useData(s => s.ready.recurringTemplates);
  const done = useRef<string>('');
  useEffect(() => {
    if (!uid || !ready || templates.length === 0) return;
    const now = new Date();
    const tag = `${uid}:${monthKey(now.getFullYear(), now.getMonth() + 1)}:${templates.length}`;
    if (done.current === tag) return;
    done.current = tag;
    generateRecurring(uid, templates, now).then(r => {
      if (r.success && (r.count ?? 0) > 0) toast.info(`Đã tạo ${r.count} khoản định kỳ cho tháng này — xem ở Dự kiến.`);
    });
  }, [uid, ready, templates]);
};
